export function ActivateSpinner() {
  const spinner = document.querySelector("#spinnerloader")
  spinner && spinner.classList.add("is-active")
}

export function DeactivateSpinner() {
  const spinner = document.querySelector("#spinnerloader")
  spinner && spinner.classList.remove("is-active")
}

window.ActivateSpinner = ActivateSpinner
window.DeactivateSpinner = DeactivateSpinner
